export default __webpack_public_path__ + "static/media/82.8e9b813e.png";